<div class="compare-duration-block">
  <select2 (valueChanged)="onTypeChange($event)" [value]="selectedOption" [data]="data" [options]="selectOptions"></select2>

  <div class="duration-inputs">
    <div class="duration-row" [class.with-label]="isRange">
      <span class="duration-label" *ngIf="isRange">{{ 'SHARED.Min_value' | translate }}:</span>
      <div class="duration-field">
        <input type="number"
               class="duration-input"
               [value]="minHours"
               (input)="onMinHoursInput($event)"
               (blur)="validateMinHours()"
               min="0"
               placeholder="0">
        <span class="field-label">{{ 'SHARED.Hours' | translate }}</span>
      </div>
      <div class="duration-field">
        <input type="number"
               class="duration-input"
               [value]="minMinutes"
               (input)="onMinMinutesInput($event)"
               (blur)="validateMinMinutes()"
               min="0"
               max="59"
               placeholder="0">
        <span class="field-label">{{ 'SHARED.Minutes' | translate }}</span>
      </div>
    </div>

    <div class="duration-row with-label" *ngIf="isRange">
      <span class="duration-label">{{ 'SHARED.Max_value' | translate }}:</span>
      <div class="duration-field">
        <input type="number"
               class="duration-input"
               [value]="maxHours"
               (input)="onMaxHoursInput($event)"
               (blur)="validateMaxHours()"
               min="0"
               placeholder="0">
        <span class="field-label">{{ 'SHARED.Hours' | translate }}</span>
      </div>
      <div class="duration-field">
        <input type="number"
               class="duration-input"
               [value]="maxMinutes"
               (input)="onMaxMinutesInput($event)"
               (blur)="validateMaxMinutes()"
               min="0"
               max="59"
               placeholder="0">
        <span class="field-label">{{ 'SHARED.Minutes' | translate }}</span>
      </div>
    </div>
  </div>
</div>
